import {Anthropic} from '@anthropic-ai/sdk';
//IA
interface ApiResponse {
    completion: string;
}

async function askClaude(name: string): Promise<any> {
    const anthropic = new Anthropic({
        apiKey: "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",
        dangerouslyAllowBrowser: true
    });

    interface FortuneResponse {
        ar: string;
        desc: string;
    }

    try {
        const message = await anthropic.messages.create({
            model: "claude-3-5-haiku-20241022",
            max_tokens: 1000,
            messages: [
                {
                    "role": "user",
                    "content": [
                        {
                            "type": "text",
                            "text": "<examples>\n<example>\n<NAME>\nGabriel\n</NAME>\n<ideal_output>\n{ar: Fresh Morning Rain on Cedar Trees, \ndesc: Like the archangel whose name you share, your presence brings messages of renewal and hope. The clean, ethereal scent of rain on cedar reflects your natural ability to cleanse negative energy and create harmony in any environment. Just as this aroma combines heavenly waters with earthly wood, you bridge the spiritual and practical realms with natural grace.}\n</ideal_output>\n</example>\n</examples>\n\n"
                        },
                        {
                            "type": "text",
                            "text": `You are tasked with generating a fortune cookie-style aroma and description based on a given name. Your response should be creative, positive, and somewhat mystical in nature.\n\nHere is the name you will be working with:\n<name>\n{${name}}\n</name>\n\nBased on this name, you need to come up with:\n1. An aroma that is somehow related to or inspired by the name\n2. A brief, meaningful description of this aroma that relates to the person's life or personality\n\nKeep in mind:\n- The aroma can be any scent, fragrance, or smell that you can connect to the name\n- The description should be positive and uplifting, avoiding any negative or mean connotations\n- Try to make the connection between the name, aroma, and description feel meaningful and slightly mystical, as if revealing a hidden truth\n\nYour response should be structured exactly as follows:\n\n{ar: [insert aroma here], \ndesc: [insert description here]\n}\n\nRemember to be creative and positive in your response, providing an interesting and uplifting message for the person with this name. The response must be in french.`
                        }
                    ]
                }
            ]
        });
        console.log("message", message);
        // Get the content from the response
        const content = message.content;
        if (!content || content.length === 0) {
            throw new Error('No content in response');
        }

        // Check if the content block is of type 'text'
        const textBlock = content[0];
        if (textBlock.type !== 'text') {
            throw new Error('Unexpected content type in response');
        }

        const responseText = textBlock.text;

        // Parse the response text to extract the JSON-like structure
        const matches = responseText.match(/\{ar:\s*([^,]+),\s*desc:\s*([^}]+)\}/);

        if (!matches) {
            throw new Error('Invalid response format');
        }

        const [_, aroma, description] = matches;

        const formattedResponse: FortuneResponse = {
            ar: aroma.trim(),
            desc: description.trim()
        };

        return formattedResponse;

    } catch (error) {
        console.error('Error calling Claude API:', error);
        throw error;
    }
}

export default askClaude;